import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/shared/user-login/login.service';
@Component({
    selector: 'app-forgotpwd',
    templateUrl: './forgotpwd.component.html',
    styleUrls: ['./forgotpwd.component.css'],
    standalone: false
})
export class ForgotpwdComponent implements OnInit {
  serverErrorMessages: string;
  successMessage: string;
  userName: string;

  constructor(private loginservice: LoginService, private router: Router) { }

  ngOnInit(): void {
    if(this.loginservice.isLoggedIn()){
     //console.log("Already logged in! Log Out first");
      this.loginservice.getUserProfile().subscribe(
        res => {
          this.router.navigateByUrl('/home');
          
        },
        err => {
         //console.log('Did not get user', err);
        });
    }
  }

  onSubmit(form) {
    this.serverErrorMessages = ""
   //console.log('Inside onSubmie',form.value);
    this.loginservice.sendOTP(form.value).subscribe(
      data => {
        this.successMessage = data.message;
       //console.log('Got resp from backend', data);
        setTimeout(() => {
          this.router.navigateByUrl('resetpwd');
         //console.log('Bye bye');
        }, 3000)
      },
      err => {
        this.serverErrorMessages = err.error.message;
       //console.log('Error sending OTP', err)
      }
    )
  }

}
